'use strict';

var _themeSections = require('@shopify/theme-sections');

var _product = require('../sections/product');

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

(0, _themeSections.load)('*');

document.addEventListener('DOMContentLoaded', function () {
  new _product2.default();
});